module.exports = __webpack_public_path__ + "img/magento-banner_small.8f866fe1.webp";